import React, { Component } from "react"
import PropTypes from "prop-types"
import { Collapse } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import { capitalizeFirstLetter } from "../../helpers/tools"
import classname from "classnames"

//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"

class Navbar extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    let matchingMenuItem = null
    const ul = document.getElementById("navigation")
    const items = ul.getElementsByTagName("a")
    for (let i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem)
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  render() {
    
    const menu =  JSON.parse(localStorage.getItem("menu"))
    
    return (  
      <React.Fragment>
        <div className="topnav">
          <div className="container-fluid">
            <nav
              className="navbar navbar-light navbar-expand-lg topnav-menu"
              id="navigation"
            >
              <Collapse
                isOpen={this.props.menuOpen}
                className="navbar-collapse"
                id="topnav-menu-content"
              >
                <ul className="navbar-nav">
                  {(menu || []).map(({ menuId = {} }, i) => (
                    <li key={i} className="nav-item dropdown">
                      {menuId &&
                      menuId.menuSubHeader &&
                      menuId.menuSubHeader.length > 0 ? (
                        <a
                          className="nav-link dropdown-toggle arrow-none"
                          style={{ fontSize: "13px", marginRight: "-8px" }}
                        >
                          <i
                            className="bx bx-home-circle me-2"
                            style={{ fontSize: "13px" }}
                          />
                          {this.props.t(capitalizeFirstLetter(menuId.menuName))}
                          <div className="arrow-down" />
                        </a>
                      ) : (
                        <Link
                          style={{
                            textTransform: "capitalize",
                            fontSize: "13px",
                          }}
                          className="nav-link dropdown-toggle arrow-none"
                          to={`${
                            menuId &&
                            menuId.menukey &&
                            menuId.menukey.substring(
                              menuId.menukey.lastIndexOf("/")
                            )
                          }`}
                        >
                          <i
                            className="bx bx-home-circle me-2"
                            style={{ fontSize: "13px" }}
                          />
                          {this.props.t(capitalizeFirstLetter(menuId.menuName))}
                          <div className="arrow-down" />
                        </Link>
                      )}
                      {menuId &&
                      menuId.menuSubHeader &&
                      menuId.menuSubHeader.length > 0 ? (
                        <div className={classname("dropdown-menu")}>
                          {(menuId.menuSubHeader || []).map(
                            ({ menuId = {}, access }, subIndex) => (
                              <React.Fragment key={subIndex}>
                                {menuId &&
                                menuId.menuItem &&
                                menuId.menuItem.length > 0 ? (
                                  <div className="dropdown">
                                    <a
                                      className="dropdown-item dropdown-toggle arrow-none"
                                      style={{ fontSize: "13px" }}
                                    >
                                      <span key="t-email-templates">
                                        {this.props.t(
                                          capitalizeFirstLetter(menuId.menuName)
                                        )}
                                      </span>{" "}
                                      <div className="arrow-down"></div>
                                    </a>
                                    <div
                                      className={classname("dropdown-menu")}
                                      style={{ fontSize: "12px" }}
                                    >
                                      {(menuId.menuItem || []).map(
                                        (item, itemIndex) => (
                                          <Link
                                            key={itemIndex}
                                            to={{
                                              pathname: `${
                                                item &&
                                                item.menuId.menukey &&
                                                item.menuId.menukey.substring(
                                                  item.menuId.menukey.lastIndexOf(
                                                    "/"
                                                  )
                                                )
                                              }`,
                                              state: {
                                                access: item.access.map(
                                                  (_) => _.accessName
                                                ),
                                              },
                                            }}
                                            className="dropdown-item d-flex flex-row justify-content-between"
                                            style={{ fontSize: "12px" }}
                                          >
                                            {this.props.t(
                                              item &&
                                                item.menuId &&
                                                capitalizeFirstLetter(
                                                  item.menuId.menuName
                                                )
                                            )}
                                            {(menuId.menuName == "My Works" &&
                                              (item.menuId.menuName ==
                                                "EW Pending" ||
                                                item.menuId.menuName ==
                                                  "EW Completed" ||
                                                item.menuId.menuName ==
                                                  "QC Completed List" ||
                                                item.menuId.menuName ==
                                                  "EW QC Completed" ||
                                                item.menuId.menuName ==
                                                  "EW Queue" ||
                                                item.menuId.menuName ==
                                                  "Pending Reworks" ||
                                                item.menuId.menuName ==
                                                  "Pending Changes" ||
                                                item.menuId.menuName ==
                                                  "pending changes")) ||
                                            (menuId.menuName ==
                                              "PL My Client" &&
                                              (item.menuId._id ==
                                                "64ca327fa3a3678d5753c713" ||
                                                item.menuId._id ==
                                                  "64e045f2d8dca079d1b417ea" ||
                                                item.menuId._id ==
                                                  "64d1ac9b274682921de40441" ||
                                                item.menuId._id ==
                                                  "64e045add8dca079d1b4178d" ||
                                                item.menuId._id ==
                                                  "64d08754913cebe1ef67d948" ||
                                                item.menuId._id ==
                                                  "64fff54ef5ceb0c309555555" ||
                                                item.menuId._id ==
                                                  "64fff58ef5ceb0c30955555f" ||
                                                item.menuId._id ==
                                                  "64d0872e913cebe1ef67d93e")) ||
                                            (menuId.menuName == "CRM POST" &&
                                              (item.menuId._id ==
                                                "64d72132712dcc2fb3183552" ||
                                                item.menuId._id ==
                                                  "64d721ac712dcc2fb3183568" ||
                                                item.menuId._id ==
                                                  "64ef609f1d3ea22e525107fc" ||
                                                item.menuId._id ==
                                                  "64feeb96b7cb70dad1cfe08f" ||
                                                item.menuId._id ==
                                                  "64feebceb7cb70dad1cffcc2" ||
                                                // item.menuId._id ==
                                                //   "64d721ac712dcc2fb3183568" ||
                                                item.menuId._id ==
                                                  "64d72177712dcc2fb318355e")) ||
                                            (menuId.menuName == "CRM PRE" &&
                                              (item.menuId._id ==
                                                "64d720b5712dcc2fb31743c4" ||
                                                item.menuId._id ==
                                                  "64d720e6712dcc2fb317bd7b" ||
                                                item.menuId._id ==
                                                  "64e0466ed8dca079d1b43eeb" ||
                                                item.menuId._id ==
                                                  "64fc623f6ae4af54d7218a10" ||
                                                item.menuId._id ==
                                                  "64fc626b6ae4af54d7218a1a" ||
                                                item.menuId._id ==
                                                  "64d7210d712dcc2fb317fa53")) ||
                                              (menuId.menuName == "inprogress" &&
                                              (item.menuId._id ==
                                                "650054286f56b39af7b70c14" ||
                                                item.menuId._id ==
                                                  "6502bddddf02fee1cd7b97ab" ||
                                                item.menuId._id ==
                                                  "650c45cb7d3c3aad6cf20292" ||
                                                item.menuId._id ==
                                                  "650c45e97d3c3aad6cf203c8" ||
                                                item.menuId._id ==
                                                  "652dffb2ca3dcf0a89503fc8" ||
                                                item.menuId._id ==
                                                  "650052d36f56b39af7b70927" ||
                                                item.menuId._id ==
                                                  "6512c021ebb478fb13c5cd89" ||
                                                item.menuId._id ==
                                                  "650054756f56b39af7b70c1e")) || 
                                              (menuId.menuName == "completed" &&
                                              (item.menuId._id ==
                                                "650a8517ad85ad20417c05a8" ||
                                                item.menuId._id ==
                                                  "650c2ccdc46438361fed92d8" ||
                                                item.menuId._id ==
                                                  "652e0001ca3dcf0a89503fe4" ||
                                                item.menuId._id ==
                                                  "652e001fca3dcf0a89503fee" ||
                                                item.menuId._id ==
                                                  "652e003cca3dcf0a89503ff8" ||
                                                item.menuId._id ==
                                                  "650c2ce8c46438361fedff79")) 
                                                  // || (menuId.menuName == "Inprogress" &&
                                                  // (item.menuId._id ==
                                                  //   "650a8517ad85ad20417c05a8" ||
                                                  //   item.menuId._id ==
                                                  //     "650c2ccdc46438361fed92d8" ||
                                                  //   item.menuId._id ==
                                                  //     "650c2ce8c46438361fedff79")) || (menuId.menuName == "Completed" &&
                                                  //     (item.menuId._id ==
                                                  //       "650a8517ad85ad20417c05a8" ||
                                                  //       item.menuId._id ==
                                                  //         "650c2ccdc46438361fed92d8" ||
                                                  //       item.menuId._id ==
                                                  //         "650c2ce8c46438361fedff79")) 
                                                          ? (
                                              <>
                                                {" "}
                                                <div className="space-between mx-1">
                                                  <span className="badge rounded-pill bg-primary">
                                                    {item.menuId.count
                                                      ? item.menuId.count
                                                      : 0}
                                                  </span>
                                                </div>
                                              </>
                                            ) : (
                                              ""
                                            )}
                                            {/* {console.log(item.menuId, "menuId")}
                                            {console.log(
                                              menuId.menuName,
                                              "menuName"
                                            )} */}
                                            {/* {console.log(
                                              item.menuId.count,
                                              "count"
                                            )} */}
                                          </Link>
                                        )
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <Link
                                    to={{
                                      pathname: `${
                                        menuId &&
                                        menuId.menukey &&
                                        menuId.menukey.substring(
                                          menuId.menukey.lastIndexOf("/")
                                        )
                                      }`,
                                      state: {
                                        access: access.map((_) => _.accessName),
                                      },
                                    }}
                                    className="dropdown-item"
                                    style={{
                                      textTransform: "capitalize",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {this.props.t(
                                      capitalizeFirstLetter(menuId.menuName)
                                    )}
                                  </Link>
                                )}
                              </React.Fragment>
                            )
                          )}
                        </div>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </Collapse>
            </nav>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

Navbar.propTypes = {
  location: PropTypes.object,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  user: PropTypes.object,
}

const mapStateToProps = (state) => {
  const { session } = state || {}
  return {
    user: session.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(Navbar)))
